<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" :width="computedWidth" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0 title-mobile" primary-title>
          {{ computedTitle }}
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout wrap>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="usuario.Descricao"
                  label="Descrição"
                  prepend-icon="person"
                  :rules="[rules.required]"
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="usuario.Email"
                  label="E-mail"
                  prepend-icon="mail"
                  :rules="[rules.required, rules.email]"
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete 
                  v-model="usuario.Colaborador"
                  :items="colaboradores"
                  item-text="Descricao"
                  return-object
                  menu-props="auto"
                  label="Colaborador"
                  no-data-text="Registro não encontrado."
                  prepend-icon="folder"
                  auto-select-first
                  :rules="[rules.required]"
                  @change="changeColaborador"
                  @focus="buscaColaboradores"
                  @click="buscaColaboradores"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6 v-if="isAdmin">
                <v-autocomplete 
                  v-model="usuario.Perfil"
                  :items="perfisAtivo"
                  item-text="Descricao"
                  return-object
                  menu-props="auto"
                  label="Perfil"
                  no-data-text="Registro não encontrado."
                  prepend-icon="folder"
                  auto-select-first
                  :rules="[rules.required]"
                  @change="changePerfil"
                  @focus="buscaPerfis"
                  @click="buscaPerfis"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Usuario from '@/domain/usuario/Usuario';

export default {
  name: 'ModalCadastroUsuario',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    usuario: {
      type: Object,
      default: () => new Usuario()
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      rules: {
        required: value => !!value || 'Campo obrigatório.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Formato do e-mail inválido.';
        }
      }
    }
  },
  computed: {
    ...mapGetters(['colaboradores', 'perfisAtivo', 'isAdmin']),
    computedTitle() {
      return this.usuario.IdUsuario ? 'Editar Usuário' : 'Novo Usuário';
    },
    computedWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '100%';
        case 'sm': return '100%';
        case 'md': return '85%';
        case 'lg': return '60%';
        case 'xl': return '50%';
      };
    },
    computedStatus() {
      return this.usuario.Status.trim();
    },
  },
  methods: {
    ...mapActions([
      'addUsuario',
      'updateUsuario',
      'fetchColaboradores',
      'fetchPerfis',
    ]),
    ...mapMutations(['showNotification', 'closeNotification']),
    async buscaColaboradores() {
      if (!this.colaboradores.length) {
        await this.fetchColaboradores();
      }
    },
    async buscaPerfis() {
      if (!this.perfisAtivo.length) {
        await this.fetchPerfis();
      }
    },
    changeColaborador(obj) {
      this.usuario.IdColaborador = obj.IdColaborador;
      this.usuario.Colaborador = obj.Descricao;
    },
    changePerfil(obj) {
      this.usuario.IdPerfil = obj.IdPerfil;
      this.usuario.Perfil = obj.Descricao;
    },
    async adiciona() {
      if (!this.usuario.IdUsuario && this.usuario.Descricao) {
        this.loading = true;
        const newUsuario = Object.assign({}, this.usuario);
        try {
          await this.addUsuario(newUsuario);
          this.showNotification({ text: `Usuário: ${newUsuario.Descricao} adicionado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('usuarioAdicionado');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao adicionar o usuário: ${error}.`, status: 'error' });
        }
      } else if (this.usuario.IdUsuario && this.usuario.Descricao) {
        this.loading = true;
        const updUsuario = Object.assign({}, this.usuario);
        try {
          await this.updateUsuario(updUsuario);
          this.showNotification({ text: `Usuário: ${updUsuario.Descricao} atualizado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('usuarioAdicionado');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao atualizar o usuário: ${error}.`, status: 'error' });
        }
      } else {
        this.loading = false;
        this.showNotification({ text: `Informe a Descrição do usuário.`, status: 'error' });
      }
    }
  },
  async created() {
    await this.buscaColaboradores();
    await this.buscaPerfis();
  }
}
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .title-mobile {
    font-size: 1rem !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
</style>
